import Icon from '@/components/ui/AppIcon';

interface InfoItem {
  icon: string;
  title: string;
  description: string;
}

interface InfoSectionProps {
  title: string;
  items: InfoItem[];
  bgColor?: string;
}

const InfoSection = ({ title, items }: InfoSectionProps) => {
  return (
    <section style={{ backgroundColor: '#0B1622' }} className="py-12">
      <div className="container mx-auto px-4">
        <h2 style={{ color: '#EAF4F8' }} className="text-3xl lg:text-4xl font-headline font-bold mb-8 text-center">
          {title}
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {items.map((item, index) => (
            <div key={index} style={{ backgroundColor: '#0F2234', border: '1px solid rgba(111,211,224,0.12)' }} className="rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div style={{ backgroundColor: 'rgba(111,211,224,0.1)' }} className="w-12 h-12 rounded-full flex items-center justify-center">
                    <Icon name={item.icon as any} size={24} style={{ color: '#6FD3E0' }} />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 style={{ color: '#EAF4F8' }} className="text-lg font-headline font-semibold mb-2">
                    {item.title}
                  </h3>
                  <p style={{ color: '#C8DDE6' }} className="text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoSection;